import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { UserModel } from '../../models/user-model/user-model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private path = environment.apiEndpoint;
  private loginStatus = new BehaviorSubject<boolean>(this.isLoggedIn());

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {
  }

  public signOutExternal = () => {
    this.cookieService.delete('isLoggedIn');
  };

  refreshToken(): Observable<any> {
    const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.httpClient.get(this.path + 'RefreshToken', {
      headers: header,
      withCredentials: true,
    });
  }

  LoginWithGoogle(credentials: string): Observable<any> {
    const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.httpClient
      .post(this.path + 'LoginWithGoogle', JSON.stringify(credentials), {
        headers: header,
        withCredentials: true,
      })
      .pipe(
        tap((response: any) => {
          // this.setLoggedIn(true);
          this.loginStatus.next(true);
        }),
        catchError((error) => {
          throw error;
        })
      );
  }


  login(Email: string, Password: string): Promise<boolean> {
    const credentials = { Email: Email.toLowerCase(), Password };
    const header = new HttpHeaders().set('Content-type', 'application/json');

    return new Promise<boolean>((resolve, reject) => {
      this.httpClient
        .post<any>(this.path + '/Login', credentials, {
          headers: header,
        })
        .subscribe(
          (response) => {
            this.setLoggedIn(true, response.token);
            this.loginStatus.next(true);

            // Guardar el ID del usuario directamente desde la respuesta del login
            if (response.user && response.user.id) {
              this.setCurrentUserId(response.user.id);
            }
            resolve(true);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  signUp(Username: string, Email: string, Password: string, ConfirmPassword: string, FirstName: string): Promise<boolean> {
    const credentials = { Username, Email, Password, ConfirmPassword, FirstName };
    const header = new HttpHeaders().set('Content-type', 'application/json');

    return new Promise<boolean>((resolve, reject) => {
      this.httpClient
        .post<any>(this.path + '/Register', credentials, {
          headers: header,
          withCredentials: false,
        })
        .subscribe(
          (response) => {
            // this.setLoggedIn(true);
            this.loginStatus.next(true);

            resolve(true);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  setLoggedIn(value: boolean, token: string): void {
    // Establecer la cookie que contiene el token JWT
    const expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 168); // 1 semana
    this.cookieService.set(
      'X-Access-Token',
      token,
      expirationDate,
      undefined,
      undefined,
      false,
      'Lax'
    );

    // Establecer la bandera de inicio de sesión (si es necesario)
    if (value) {
      this.cookieService.set(
        'isLoggedIn',
        'true',
        expirationDate,
        undefined,
        undefined,
        false,
        'Lax'
      );
    } else {
      this.cookieService.delete('isLoggedIn');
    }
  }

  // Método para guardar el ID del usuario en localStorage
  setCurrentUserId(userId: number): void {
    localStorage.setItem('currentUserId', userId.toString());
  }

  // Método para obtener el ID del usuario desde localStorage
  getCurrentUserId(): number | null {
    const userId = localStorage.getItem('currentUserId');
    return userId ? parseInt(userId) : null;
  }

  // Método para limpiar el ID del usuario al hacer logout
  clearCurrentUserId(): void {
    localStorage.removeItem('currentUserId');
  }


  isLoggedIn(): boolean {
    return this.cookieService.check('isLoggedIn').valueOf();
  }

  getHttpOptions() {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    // Agregar el ID del usuario si está disponible
    const currentUserId = this.getCurrentUserId();
    if (currentUserId) {
      headers['X-User-Id'] = currentUserId.toString();
    }

    return {
      headers: new HttpHeaders(headers),
    };
  }

  getColors(): Observable<any> {
    const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.httpClient.get(this.path + 'GetColorList', {
      headers: header,
      withCredentials: true,
    });
  }

  logOut(): any {
    this.revokeToken().subscribe((response) => {
    });
    this.signOutExternal();
    this.clearCurrentUserId();
  }

  revokeToken(): Observable<any> {
    const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.httpClient.delete(this.path + 'RevokeToken', {
      headers: header,
      withCredentials: true,
    });
  }

  getUserLogged(): Observable<UserModel> {
    const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.httpClient.get<UserModel>(this.path + 'GetUserFromToken', {
      headers: header,
      withCredentials: true,
    });
  }
}
